module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/banner_maripic-fff4df196c26684b7d6faa6d56e082bb.webp";